import React from 'react';
import './Loader.css';
import { FormattedMessage } from 'react-intl';

const Loader = () => {
  

  return (
    <div className="loader-container">
      <div className="loader-wrapper">
        <div className="loader">
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
          <div className="loader-shadow"></div>
          <div className="loader-shadow"></div>
          <div className="loader-shadow"></div>
        </div>
        <div className="loader-text"><FormattedMessage id='loading' /></div>
      </div>
    </div>
  );
};

export default Loader; 